import Backbone   from "backbone";
import {defaults} from "../../commun/backbone/decorators";
import Translator from "bazinga-translator";

@defaults({
                language_is_visible: false,
                languages : [],
                base_image_url: '',
                default_language: '',
                user_languagecode: 0,
                request_locale: '',
          })
class LoginBaseModel extends Backbone.Model
{
    findLanguage(codeOrLocale, returnDefaultIfNotFound=false)
    {
        const languages = this.get('languages');
        if (parseInt(codeOrLocale)){
            codeOrLocale = parseInt(codeOrLocale); //pour être sur qu'on a entier

            let lang = languages.find(function(language){ return language.code === codeOrLocale;});
            if (lang || !returnDefaultIfNotFound){
                return lang;
            }

            //il faut chercher le langage par defaut
            const nPrimary = parseInt(codeOrLocale) & 0x3ff;
            return languages.find(function(language){ return (language.principal === nPrimary) && language.default;});
        }

        //c'est pas un code mais une locale
        codeOrLocale = codeOrLocale.replace('-', '_');
        let lang = languages.find(function(language){ return language.short === codeOrLocale;});
        if (lang || !returnDefaultIfNotFound){
            return lang;
        }
        const sPrimary = codeOrLocale.substring(0, 3);
        return languages.find(function(language){ return (language.short.startsWith(sPrimary)) && language.default;});
    }

    loadUserLanguage(code)
    {
        this.trigger('show-languages'); //on raffiche temporairement les langues
        this.trigger('reset-alert');
        if (!code)
        {
            return;
        }

        let isFallback = false;
        let language = this.findLanguage(code, true);
        if (!language){
            isFallback = true;
            language = this.findLanguage(2057, true); //en_GB en fallback
        }
        this.trigger('load-language', language);
        if ((language.code === code) || !isFallback){
            this.trigger('hide-languages', language.code !== code ? language.code & 0x3ff : 0);
        }
        if (language.code !== code){
            this.trigger('set-alert-warning', Translator.trans('login.warning_locale', {}, 'js'));
        }
    }


    initLanguage()
    {
        const languages = this.get('languages');
        if (languages.length === 0){
            return ;
        }
        const userLanguageCode = this.get('user_languagecode');
        if (!userLanguageCode){
            return this.loadLanguage(null);
        }
        return this.loadUserLanguage(parseInt(userLanguageCode));
    }

    loadLanguage(code) {
        const languages = this.get('languages');
        if (languages.length === 0){
            return ;
        }

        if (!code){
            code = this.get('request_locale');
        }

        let language = this.findLanguage(code);
        if(!language)
        {
            //on cherche avec le language du navigateur pour voir si on trouve
            language = this.findLanguage(navigator.language);
            if(!language){
                language = this.findLanguage(this.get('default_language'));
                if(!language){
                    language = languages[0];
                }
            }
        }

        this.trigger('load-language', language);
    };

}
export default LoginBaseModel;